import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getNewCount } from "@/api/data";
import infoList from "@/mixins/infoList";
import serverList from "../../components/serverList/serverOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import DataOptions from "../../components/timeList/dataOptions.vue";
export default {
  mixins: [infoList],
  components: {
    serverList: serverList,
    VxeTable: VxeTable,
    DataOptions: DataOptions
  },
  data: function data() {
    var h = this.$createElement;
    return {
      listApi: getNewCount,
      searchInfo: {
        server_id: []
      },
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableColumn: [{
        field: "date_str",
        title: "日期",
        sortable: true,
        width: 100
      }, {
        field: "new_role",
        title: "新增",
        sortable: true
      }, {
        field: "new_watchers_count",
        title: "广告人数",
        width: 150,
        titleHelp: {
          "content": "新增广告率 = 新增广告人数 / 新增角色"
        },
        sortable: true,
        slots: {
          default: function _default(_ref) {
            var row = _ref.row;
            return [h("span", [row.new_watchers_count, "\uFF08", row.new_watch_video_rate, "%\uFF09"])];
          }
        }
      }, {
        field: "new_user_watch_video_count",
        title: "广告次数",
        sortable: true
      }, {
        field: "new_average_watch_video_count",
        title: "人均广告",
        titleHelp: {
          "content": "新增人均广告次数 = 新增广告次数 / 新增广告人数"
        },
        sortable: true
      }, {
        field: "new_role_login",
        title: "人均访问",
        sortable: true
      }, {
        field: "new_start_av",
        title: "人均开始关卡",
        sortable: true
      }, {
        field: "new_win_av",
        title: "人均通关",
        sortable: true
      }, {
        field: "new_win_rate_1",
        title: "第1关通关率",
        sortable: true,
        slots: {
          default: function _default(_ref2) {
            var row = _ref2.row;
            return [h("span", [row.new_win_rate_1, "%"])];
          }
        }
      }, {
        field: "new_win_rate_2",
        title: "第2关通关率",
        sortable: true,
        slots: {
          default: function _default(_ref3) {
            var row = _ref3.row;
            return [h("span", [row.new_win_rate_2, "%"])];
          }
        }
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.searchEvent();
            _this.footDataToFirst();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    footDataToFirst: function footDataToFirst() {
      var arr1 = document.getElementsByClassName("vxe-table--footer-wrapper");
      var arr2 = document.getElementsByClassName("vxe-table--body-wrapper");
      if (arr2[0]) {
        arr2[0].parentNode.insertBefore(arr1[0], arr2[0]);
      }
    },
    searchEvent: function searchEvent() {
      this.searchInfo.sdate = this.formData[0];
      this.searchInfo.edate = this.formData[1];
      this.loadTatleData();
    },
    loadTatleData: function loadTatleData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getTableData();
            case 2:
              if (!_this2.tableData) {
                _this2.$message({
                  message: "暂无数据"
                });
              } else if (_this2.tableData && _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};